import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    DialogContent,
    MenuItem,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import DraggableDialog from '../../../../ui/draggableDialog';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../../utils/environment';
import { ContactLensConfigurationService } from '../../../../../service/validDataService';
import { initialValuesScheduleForm } from './contactLensScheduleInputForm';

const validationSchema = Yup.object({
    name: Yup.string().required('Schedule name is required'),
    daysSupply: Yup.number()
        .positive('Days supply must be positive')
        .integer('Days supply must be a whole number')
        .required('Days supply is required'),
});

export default function EditContactLensScheduleForm({ open, onClose, onRecordEdit, recordToEdit, isCopy = false }) {

    const handleSubmit = async (values, { resetForm }) => {
        try {
            let response;

            if (isCopy) {
                const { id, ...newValues } = values;
                response = await ContactLensConfigurationService.addSchedule(newValues);
            } else {
                response = await ContactLensConfigurationService.updateSchedule(values);
            }
            
            const { code, data, message } = response;
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordEdit(data);
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.log(error);
            }
            toast.error('Failed to update contact lens schedule');
        }
    };

    return (
        <DraggableDialog title={isCopy ? "Copy Contact Lens Schedule" : "Edit Contact Lens Schedule"} onClose={onClose} open={open} width={'sm'}>
            <DialogContent sx={{ mt: 1, mb: 1 }}>
                <Formik
                    initialValues={{ ...initialValuesScheduleForm, ...recordToEdit }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="name"
                                        label="Schedule Name"
                                        required
                                        fullWidth
                                        size="small"
                                        helperText="e.g., Daily, Biweekly, Monthly, Yearly"
                                    />
                                    <ErrorMessage name="name">{message => <Typography color={'error'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="daysSupply"
                                        label="Days Supply"
                                        type="number"
                                        required
                                        fullWidth
                                        size="small"
                                        helperText="Number of days this schedule covers"
                                    />
                                    <ErrorMessage name="daysSupply">{message => <Typography color={'error'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (isCopy ? 'Copying...' : 'Updating...') : (isCopy ? 'Copy Schedule' : 'Update Schedule')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog>
    );
}
